export default "__VITE_ASSET__DkJmDZfL__"